// Module
var code = "{{vm.field}}<p>{{vm.field.name}}</p>";
// Exports
module.exports = code;